<div class="cart-prompt">

  @if (choicesList?.length > 0 || choicesMandatory) {
  @if (choicesList?.length > 0) {
  @if (choicesList?.length <= 6
     &&
     choicesDisplayMode
     !=='DropDown'
     )
     {
     <!--
     Selection
     List
     -->
    <mat-selection-list [multiple]="false"
                        class="cart-promp-choices-list"
                        (selectionChange)="onChoiceChanged($event.options[0]?.value)"
                        [hideSingleSelectionIndicator]="true"
                        [disabled]="readonly">
      <div mat-subheader>{{ commentTitle | transloco }}</div>
      @if (control?.touched && control?.hasError('choiceRequired')) {
      <div @errorInOutAnimation
           class="cart-prompt-errors">
        <mat-error>
          {{ 'COMMON.ERRORS.FIELD_REQUIRED_FORMAT' | transloco : { field: (commentTitle | transloco) } }}
        </mat-error>
      </div>
      }
      @for (choiceItem of choicesList; track choiceItem.value) {
      <mat-list-option [value]="choiceItem.value"
                       [selected]="choiceItem.value === selectedChoice"
                       [disabled]="choiceItem.disabled === 'true'">
        {{choiceItem.value}}
      </mat-list-option>
      }
    </mat-selection-list>
    } @else {
    <mat-form-field class="cart-promp-choices-dropdownfield">
      <mat-label>{{ commentTitle | transloco }}</mat-label>
      <mat-select [formControl]="selectedChoiceInputControl">
        @if (choicesList?.length > 5) {
        <mat-option>
          <mat-select-search [list]="choicesList"
                             [searchProperties]="['value']"
                             (filtered)="filteredChoices = $event"
                             [searchPlaceholder]="(commentTitle || 'SEARCH.SEARCH_PLACEHOLDER') | transloco">
          </mat-select-search>
        </mat-option>
        }
        @for (choice of filteredChoices; track choice) {
        <mat-option [value]="choice.value"
                    [disabled]="choice.disabled">
          {{choice.value}}
        </mat-option>
        }
      </mat-select>
      @if (control?.touched && control?.hasError('choiceRequired')) {
      <mat-error>
        {{ 'COMMON.ERRORS.FIELD_REQUIRED_FORMAT' | transloco : { field: (commentTitle | transloco) } }}
      </mat-error>
      }
    </mat-form-field>
    }
    } @else {
    <mat-error>
      {{ 'COMMON.ERRORS.FIELD_REQUIRED_FORMAT' | transloco : { field: (commentTitle | transloco) } }}
    </mat-error>
    <mat-error>
      {{ 'CART.PROMPT_NO_CHOICE_AVAILABLE' | transloco }}
    </mat-error><!-- <div>Aucun élément disponible, veuillez choisir une autre date ou commander plus tard</div> -->
    }
    }
    <!-- comment, can be mandatory -->
    @if (displayComment) {
    <mat-form-field class="cart-prompt-field">
      <mat-label>{{ (( (choicesMandatory && 'CART.PROMPT_COMMENT') || commentTitle || 'CART.PROMPT_COMMENT' ) | transloco ) + (commentMandatory ? ' *': '') }}</mat-label>
      <mat-icon matPrefix
                color="primary">chat_bubble_outline</mat-icon>
      <input matInput
             type="text"
             [formControl]="userCommentInputControl" />
      @if (control?.touched && control?.hasError('commentRequired')) {
      <mat-error>
        {{ 'COMMON.ERRORS.FIELD_REQUIRED_FORMAT' | transloco : { field: ((choicesMandatory && 'CART.PROMPT_COMMENT') || commentTitle || 'CART.PROMPT_COMMENT' ) | transloco } }}
      </mat-error>
      }
    </mat-form-field>
    }

</div>
